import { useEffect, useState } from "react";

/**
 * Version « ordinateur » : assez large ET assez haut. La hauteur écarte le téléphone tenu en
 * paysage, plus large que 768px mais sous 450px de haut.
 *
 * Même règle que l'écran `md` de `tailwind.config.js`, à garder alignés.
 */
const DESKTOP_MEDIA_QUERY = "(min-width: 768px) and (min-height: 500px)";
const PHONE_LANDSCAPE_MEDIA_QUERY =
  "(orientation: landscape) and (max-height: 499px)";

/**
 * - `desktop` : barre latérale ;
 * - `mobile` : navbar en bas ;
 * - `phone-landscape` : téléphone tourné. Le site n'est pas conçu pour, seule la vue distante
 *   l'accepte (l'écran du produit est lui-même en paysage) ; ailleurs, on demande de le
 *   remettre en portrait.
 */
export type LayoutMode = "desktop" | "mobile" | "phone-landscape";

const currentMode = (): LayoutMode =>
  window.matchMedia(DESKTOP_MEDIA_QUERY).matches
    ? "desktop"
    : window.matchMedia(PHONE_LANDSCAPE_MEDIA_QUERY).matches
      ? "phone-landscape"
      : "mobile";

export const useLayoutMode = (): LayoutMode => {
  const [mode, setMode] = useState(currentMode);

  useEffect(() => {
    const queries = [DESKTOP_MEDIA_QUERY, PHONE_LANDSCAPE_MEDIA_QUERY].map(
      (q) => window.matchMedia(q)
    );
    const update = () => setMode(currentMode());

    update();
    queries.forEach((q) => q.addEventListener("change", update));
    return () =>
      queries.forEach((q) => q.removeEventListener("change", update));
  }, []);

  return mode;
};
